import { WorkPrintPage } from './WorkPrintPage';

export { WorkPrintPage };
export const Component = WorkPrintPage;
export default WorkPrintPage;
